import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Navbar, Footer, ThemeProvider } from "@/components";
import Home from "@/pages/home/Home";
import Services from "@/pages/services/Services";
import Gallery from "@/pages/gallery/Gallery";
import Contact from "@/pages/contact/Contact";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
